"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColor = exports.getCircularVariantStyle = exports.getVariantStyle = exports.getTypographyStyle = exports.getSizeStyle = void 0;
const types_1 = require("../types");
const getSizeStyle = ({ size, isCircular, theme, }) => {
    if (isCircular) {
        switch (size) {
            case types_1.buttonSize.large: {
                return {
                    width: theme.heightLargeV2,
                    height: theme.heightLargeV2,
                    padding: theme.paddingLargeV2,
                };
            }
            case types_1.buttonSize.small:
                return {
                    width: theme.heightSmall,
                    height: theme.heightSmall,
                    padding: theme.paddingSmall,
                };
            case types_1.buttonSize.big:
                return {
                    width: theme.heightLarge,
                    height: theme.heightLarge,
                    padding: theme.paddingLarge,
                };
            case types_1.buttonSize.medium:
            default:
                return {
                    width: theme.heightMedium,
                    height: theme.heightMedium,
                    padding: theme.paddingMedium,
                };
        }
    }
    switch (size) {
        case types_1.buttonSize.large:
            return {
                minHeight: theme.heightLargeV2,
                padding: theme.paddingLargeV2,
            };
        case types_1.buttonSize.small:
            return {
                minHeight: theme.heightSmall,
                padding: theme.paddingSmall,
            };
        case types_1.buttonSize.big:
            return {
                minHeight: theme.heightLarge,
                padding: theme.paddingLarge,
            };
        case types_1.buttonSize.medium:
        default:
            return {
                minHeight: theme.heightMedium,
                padding: theme.paddingMedium,
            };
    }
};
exports.getSizeStyle = getSizeStyle;
const getTypographyStyle = ({ size, theme, }) => {
    // TO BE DEPRECATED
    if (theme.isClassic) {
        return {
            fontSize: theme.fontSize,
            fontFamily: theme.fontFamily,
            fontWeight: theme.fontWeight,
            lineHeight: theme.lineHeight,
            letterSpacing: 'unset',
        };
    }
    switch (size) {
        case types_1.buttonSize.large:
            return {
                fontSize: theme.fontSizeLarge,
                fontFamily: theme.fontFamilyLarge,
                fontWeight: theme.fontWeightLarge,
                lineHeight: theme.lineHeightLarge,
                letterSpacing: theme.letterSpacingLarge,
            };
        case types_1.buttonSize.small:
            return {
                fontSize: theme.fontSizeSmall,
                fontFamily: theme.fontFamilySmall,
                fontWeight: theme.fontWeightSmall,
                lineHeight: theme.lineHeightSmall,
                letterSpacing: theme.letterSpacingSmall,
            };
        case types_1.buttonSize.medium:
        default:
            return {
                fontSize: theme.fontSizeMedium,
                fontFamily: theme.fontFamilyMedium,
                fontWeight: theme.fontWeightMedium,
                lineHeight: theme.lineHeightMedium,
                letterSpacing: theme.letterSpacingMedium,
            };
    }
};
exports.getTypographyStyle = getTypographyStyle;
const getVariantStyle = ({ variant, theme, }) => {
    switch (variant) {
        case types_1.buttonVariant.secondary: {
            return {
                backgroundColor: theme.backgroundColorSecondary,
                backgroundColorHover: theme.backgroundColorSecondaryHover,
                backgroundColorActive: theme.backgroundColorSecondaryActive,
                backgroundColorDisabled: theme.backgroundColorSecondaryDisabled,
                borderColor: theme.borderColorSecondary,
                borderColorHover: theme.borderColorSecondaryHover,
                borderColorActive: theme.borderColorSecondaryActive,
                borderColorDisabled: theme.borderColorSecondaryDisabled,
                shadowColorFocus: theme.shadowColorSecondaryFocus,
                shadowBackgroundColorFocus: theme.shadowBackgroundColorFocus,
                fontColor: theme.fontColorSecondary,
                fontColorDisabled: theme.fontColorSecondaryDisabled,
            };
        }
        case types_1.buttonVariant.tertiary: {
            return {
                backgroundColor: theme.backgroundColorTertiary,
                backgroundColorHover: theme.backgroundColorTertiaryHover,
                backgroundColorActive: theme.backgroundColorTertiaryActive,
                backgroundColorDisabled: theme.backgroundColorTertiaryDisabled,
                borderColor: theme.borderColorTertiary,
                borderColorHover: theme.borderColorTertiaryHover,
                borderColorActive: theme.borderColorTertiaryActive,
                borderColorDisabled: theme.borderColorTertiaryDisabled,
                borderSize: theme.borderSizeTertiary,
                shadowColorFocus: theme.shadowColorTertiaryFocus,
                shadowBackgroundColorFocus: theme.shadowBackgroundColorFocus,
                fontColor: theme.fontColorTertiary,
                fontColorActive: theme.fontColorTertiaryActive,
                fontColorHover: theme.fontColorTertiaryHover,
                fontColorDisabled: theme.fontColorTertiaryDisabled,
            };
        }
        case types_1.buttonVariant.tertiaryReversed: {
            return {
                backgroundColor: theme.backgroundColorTertiaryReversed,
                backgroundColorHover: theme.backgroundColorTertiaryReversedHover,
                backgroundColorActive: theme.backgroundColorTertiaryReversedActive,
                backgroundColorDisabled: theme.backgroundColorTertiaryReversedDisabled,
                borderColor: theme.borderColorTertiaryReversed,
                borderColorHover: theme.borderColorTertiaryReversedHover,
                borderColorActive: theme.borderColorTertiaryReversedActive,
                borderColorDisabled: theme.borderColorTertiaryReversedDisabled,
                borderSize: theme.borderSizeTertiary,
                shadowColorFocus: theme.shadowColorTertiaryFocus,
                shadowBackgroundColorFocus: theme.shadowBackgroundColorFocus,
                fontColor: theme.fontColorTertiaryReversed,
                fontColorActive: theme.fontColorTertiaryReversedActive,
                fontColorHover: theme.fontColorTertiaryReversedHover,
                fontColorDisabled: theme.fontColorTertiaryReversedDisabled,
            };
        }
        case types_1.buttonVariant.text: {
            return {
                backgroundColor: 'transparent',
                backgroundColorHover: 'transparent',
                backgroundColorActive: 'transparent',
                backgroundColorDisabled: 'transparent',
                borderColor: theme.borderColorPrimary,
                borderColorHover: theme.borderColorPrimaryHover,
                borderColorActive: theme.borderColorPrimaryActive,
                borderColorDisabled: theme.borderColorPrimaryDisabled,
                shadowColorFocus: theme.shadowColorPrimaryFocus,
                shadowBackgroundColorFocus: theme.shadowBackgroundColorFocus,
                fontColor: theme.backgroundColorPrimary,
                fontColorActive: theme.backgroundColorPrimaryActive,
                fontColorHover: theme.backgroundColorPrimaryHover,
                fontColorDisabled: theme.fontColorPrimaryDisabled,
            };
        }
        case types_1.buttonVariant.destructive: {
            return {
                backgroundColor: theme.backgroundColorDestructive,
                backgroundColorHover: theme.backgroundColorDestructiveHover,
                backgroundColorActive: theme.backgroundColorDestructiveActive,
                backgroundColorDisabled: theme.backgroundColorDestructiveDisabled,
                borderColor: theme.borderColorDestructive,
                borderColorHover: theme.borderColorDestructiveHover,
                borderColorActive: theme.borderColorDestructiveActive,
                borderColorDisabled: theme.borderColorDestructiveDisabled,
                shadowColorFocus: theme.shadowColorDestructiveFocus,
                shadowBackgroundColorFocus: theme.shadowBackgroundColorFocus,
                fontColor: theme.fontColorDestructive,
                fontColorDisabled: theme.fontColorDestructiveDisabled,
            };
        }
        case types_1.buttonVariant.success: {
            return {
                backgroundColor: theme.backgroundColorSuccess,
                backgroundColorHover: theme.backgroundColorSuccessHover,
                backgroundColorActive: theme.backgroundColorSuccessActive,
                backgroundColorDisabled: theme.backgroundColorSuccessDisabled,
                borderColor: theme.borderColorSuccess,
                borderColorHover: theme.borderColorSuccessHover,
                borderColorActive: theme.borderColorSuccessActive,
                borderColorDisabled: theme.borderColorSuccessDisabled,
                shadowColorFocus: theme.shadowColorSuccessFocus,
                shadowBackgroundColorFocus: theme.shadowBackgroundColorFocus,
                fontColor: theme.fontColorSuccess,
                fontColorDisabled: theme.fontColorSuccessDisabled,
            };
        }
        case types_1.buttonVariant.primary:
        default: {
            return {
                backgroundColor: theme.backgroundColorPrimary,
                backgroundColorHover: theme.backgroundColorPrimaryHover,
                backgroundColorActive: theme.backgroundColorPrimaryActive,
                backgroundColorDisabled: theme.backgroundColorPrimaryDisabled,
                borderColor: theme.borderColorPrimary,
                borderColorHover: theme.borderColorPrimaryHover,
                borderColorActive: theme.borderColorPrimaryActive,
                borderColorDisabled: theme.borderColorPrimaryDisabled,
                shadowColorFocus: theme.shadowColorPrimaryFocus,
                shadowBackgroundColorFocus: theme.shadowBackgroundColorFocus,
                fontColor: theme.fontColorPrimary,
                fontColorDisabled: theme.fontColorPrimaryDisabled,
            };
        }
    }
};
exports.getVariantStyle = getVariantStyle;
const getCircularVariantStyle = ({ variant, theme, }) => {
    switch (variant) {
        case types_1.buttonVariant.secondary:
            return {
                fontColor: theme.fontColorSecondary,
                fontColorDisabled: theme.fontColorSecondaryDisabled,
            };
        case types_1.buttonVariant.tertiary:
            return {
                fontColor: theme.fontColorTertiary,
                fontColorActive: theme.fontColorTertiaryActive,
                fontColorHover: theme.fontColorTertiaryHover,
                fontColorDisabled: theme.fontColorTertiaryDisabled,
            };
        case types_1.buttonVariant.tertiaryReversed:
            return {
                fontColor: theme.fontColorTertiaryReversed,
                fontColorActive: theme.fontColorTertiaryReversedActive,
                fontColorHover: theme.fontColorTertiaryReversedHover,
                fontColorDisabled: theme.fontColorTertiaryReversedDisabled,
            };
        case types_1.buttonVariant.success:
            return {
                fontColor: theme.fontColorSuccess,
                fontColorDisabled: theme.fontColorSuccessDisabled,
            };
        case types_1.buttonVariant.destructive:
            return {
                fontColor: theme.fontColorDestructive,
                fontColorDisabled: theme.fontColorDestructiveDisabled,
            };
        case types_1.buttonVariant.primary:
        default:
            return {
                fontColor: theme.fontColorPrimary,
                fontColorDisabled: theme.fontColorPrimaryDisabled,
            };
    }
};
exports.getCircularVariantStyle = getCircularVariantStyle;
const getColor = (props, style) => {
    if (props['aria-disabled']) {
        return style.fontColorDisabled;
    }
    if (props.isHovered && style.fontColorHover) {
        return style.fontColorHover;
    }
    if (props.isActive && style.fontColorActive) {
        return style.fontColorActive;
    }
    return style.fontColor;
};
exports.getColor = getColor;
